import { CircularProgress, Link, TableBody, TableCell, TableRow } from '@material-ui/core';
import { useTranslations } from '@react/lib/i18n';
import React from 'react';
import { Waypoint } from 'react-waypoint';
import { LoaderWrapper, StyledTable, StyledTableFooter, StyledTableHead, StyledTableRow } from './index.styled';
var ReportsTable = function (_a) {
    var data = _a.data, loading = _a.loading, onScrollToEnd = _a.onScrollToEnd;
    var t = useTranslations().t;
    return (React.createElement(React.Fragment, null,
        React.createElement(StyledTable, null,
            React.createElement(StyledTableHead, null,
                React.createElement(TableCell, null, "Id"),
                React.createElement(TableCell, null, "File size (bytes)")),
            React.createElement(TableBody, null, data.map(function (report) { return (React.createElement(StyledTableRow, null,
                React.createElement(TableCell, null,
                    React.createElement(Link, { href: report.url }, report.id)),
                React.createElement(TableCell, null, report.sizeBytes))); })),
            React.createElement(StyledTableFooter, null,
                React.createElement(TableRow, null, loading && (React.createElement(TableCell, { colSpan: 2 },
                    React.createElement(LoaderWrapper, { "data-testid": "Loader" },
                        React.createElement(CircularProgress, null))))))),
        React.createElement(Waypoint, { onEnter: onScrollToEnd })));
};
var ɵ0 = ReportsTable;
export default ReportsTable;
export { ɵ0 };
